// extracted by mini-css-extract-plugin
module.exports = {"panel":"styles-module__panel___2uUtG"};